import React, { useState, useEffect } from 'react';
import { useIntl, getLocale } from 'umi';
import { Table, Segment, notification } from 'tea-component';
const { selectable, pageable, sortable, scrollable, autotip } = Table.addons;
import './index.scss';
import NoData from '@/pages/intelligence/components/NoData';
import { history } from 'umi';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import {
  formatNum,
  formatPercentNum,
} from '@/pages/intelligence/utils/commonUtils';
import global from '@/pages/intelligence/assets/svg/flag/global.svg';
import defaultIcon from '@/pages/intelligence/assets/svg/flag/default.svg';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { addV2Prefix } from '@/pages/intelligence/utils/commonUtils';

export default function AnnualTable(props: any) {
  const {
    pageId,
    tableData,
    changeMpTableSort,
    sortColunms,
    regionsCountries
  } = props;
  const { formatMessage } = useIntl();
  const allMarkets = regionsCountries?.map((area: any) => area.country_set).flat() || []
  const isEN = getLocale() === 'en-US'

  //跳转到游戏详情
  const gotoDetailsPage = (val: any, jump = true) => {
    const path = `/intelligence/MarketProfile/Overview/detail?marketName=${val.marketName}&marketNameEn=${val.marketNameEn}&pageId=${pageId}`

    if (jump) {
      buriedBtnPoint({
        ...dbiBtnLogMes.marketProfileAnnualClickMarket,
        extInfo: val.marketName,
      });
      return history.push(path);
    }
    else return path
  };

  const annualColumns = [
    {
      key: 'marketName',
      header: (
        <div className="dbi-marketprofile-table-title">
          <span>#</span> {formatMessage({ id: 'dbi_market' })}
        </div>
      ),
      render: (item: any) => {
        const href = gotoDetailsPage(item, false)
        return (
          <ARightClickToJump
            href={addV2Prefix(href)}
            style={{ display: 'inline' }}
          >
            <div
              className="dbi-marketprofile-table-cont"
              onClick={() => {
                if (
                  item.marketNameEn != 'global' &&
                  item.marketNameEn != 'global_wo_china'
                ) {
                  // buriedBtnPoint({
                  //   ...dbiBtnLogMes.marketProfileAnnualClickMarket,
                  //   extInfo: item.marketName,
                  // });
                  // history.push({
                  //   pathname: '/MarketProfile/MarketDetail/MarketDetailsOverview',
                  //   query: {
                  //     pageId: 'MarketProfilMobile',
                  //     marketName: item.marketName,
                  //     marketNameEn: item.marketNameEn,
                  //   },
                  // });
                  gotoDetailsPage(item)
                }
              }}
            >
              <span className="dbi-marketprofile-table-rank">{item?.rank}</span>
              <div className="dbi-marketprofile-table-img">
                {item.marketFlag ? (
                  <img
                    className={
                      item.marketNameEn != 'global' &&
                        item.marketNameEn != 'global_wo_china'
                        ? 'normalFlag'
                        : 'globalFlag'
                    }
                    src={item.marketFlag}
                    onError={(e: any) => {
                      e.target.onerror = null;
                      if (item.marketNameEn.indexOf('global') != -1) {
                        e.target.src = global;
                      } else {
                        e.target.src = defaultIcon;
                      }
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
              <span
                className={`dbi-marketprofile-table-text ${item.marketNameEn != 'global' &&
                    item.marketNameEn != 'global_wo_china'
                    ? 'hover-style'
                    : ''
                  }`}
              >
                {allMarkets?.find((market: any) => market.country_code === item.marketNameEn)?.[isEN ? 'country_name_en' : 'country_name_ch'] || item.marketName}
              </span>
            </div>
          </ARightClickToJump>
        );
      },
    },
    {
      key: 'Total Revenue',
      header: () => {
        return (
          <CloumsCenter width={220} align={'right'}>
            <SortBy
              type="font_sort"
              filter={changeMpTableSort}
              defaultKey={sortColunms[0]}
              defaultValue={'desc'}
              title={formatMessage({ id: 'dbi_total_rev_$' })}
              list={[
                {
                  key: `revenue`,
                  sortMetric: '',
                  orderSource: 'dataai',
                  text: formatMessage({ id: 'dbi_revenue_$' }),
                  title: formatMessage({ id: 'dbi_total_rev_$' }),
                  ratioType: 0,
                },
                {
                  key: `revenueChange`,
                  sortMetric: '',
                  orderSource: 'dataai',
                  text: `${formatMessage({
                    id: 'dbi_revenue_$',
                  })}:${formatMessage({ id: 'dbi_change' })}(%)`,
                  title: `${formatMessage({ id: 'dbi_total_rev_$' })}($)(%)`,
                  ratioType: 1,
                },
              ]}
            />
          </CloumsCenter>
        );
      },
      align: 'center',
      render: (item: any) => (
        <CloumsCenter width={220} align={'right'}>
          <div className="dbi-marketprofile-table-end">
            <TableShowData
              value={
                item['marketRevenue'] == 0
                  ? '-'
                  : formatNum(item['marketRevenue'], true)
              }
              type={
                item['marketRevenuePrecent'] != 0
                  ? item['marketRevenuePrecent'] < 0
                    ? 'down'
                    : 'up'
                  : '-'
              }
              growth={
                item['marketRevenuePrecent'] == 0
                  ? '-'
                  : formatPercentNum(item['marketRevenuePrecent'])
              }
            />
          </div>
        </CloumsCenter>
      ),
    },
    {
      key: 'Game Count',
      header: () => {
        return (
          <CloumsCenter width={180} align={'right'}>
            <SortBy
              type="font_sort"
              filter={changeMpTableSort}
              title={formatMessage({ id: 'dbi_market_game_count' })}
              defaultKey={sortColunms[0]}
              defaultValue={'desc'}
              list={[
                {
                  key: `gameCount`,
                  sortMetric: '',
                  orderSource: 'dataai',
                  text: formatMessage({ id: 'dbi_market_game_count' }),
                  title: formatMessage({ id: 'dbi_market_game_count' }),
                  ratioType: 0,
                },
                {
                  key: `gameCountChange`,
                  sortMetric: '',
                  orderSource: 'dataai',
                  text: `${formatMessage({
                    id: 'dbi_market_game_count',
                  })}:${formatMessage({ id: 'dbi_change' })}(%)`,
                  title: `${formatMessage({ id: 'dbi_market_game_count' })}(%)`,
                  ratioType: 1,
                },
              ]}
            />
          </CloumsCenter>
        );
      },
      align: 'center',
      render: (item: any) => (
        <CloumsCenter width={180} align={'right'}>
          <div className="dbi-marketprofile-table-end">
            <TableShowData
              value={
                item['gameCount'] == 0
                  ? '-'
                  : formatNum(item['gameCount'], true)
              }
              type={
                item['gameCountPrecent'] != 0
                  ? item['gameCountPrecent'] < 0
                    ? 'down'
                    : 'up'
                  : '-'
              }
              growth={
                item['gameCountPrecent'] == 0
                  ? '-'
                  : formatPercentNum(item['gameCountPrecent'])
              }
            />
          </div>
        </CloumsCenter>
      ),
    },
    {
      key: 'settings',
      header: (
        <CloumsCenter width={100} align={'left'} titleStyle={true}>
          {formatMessage({ id: 'dbi_actions' })}
        </CloumsCenter>
      ),
      align: 'center',
      render: (item: any) => {
        return (
          <CloumsCenter width={100} align={'left'}>
            {item.marketNameEn == 'global' ||
              item.marketNameEn == 'global_wo_china' ? (
              '-'
            ) : (
              <div
                className={'dbi-marketprofile-table-details'}
                onClick={() => {
                  if (
                    item.marketNameEn != 'global' &&
                    item.marketNameEn != 'global_wo_china'
                  ) {
                    buriedBtnPoint({
                      ...dbiBtnLogMes.marketProfileAnnualClickMarket,
                      extInfo: item.marketName,
                    });

                    history.push({
                      pathname: '/intelligence/MarketProfile/Overview/detail',
                      query: {
                        marketName: item.marketName,
                        marketNameEn: item.marketNameEn,
                        pageId,
                      },
                    });
                  }
                }}
              >
                {formatMessage({ id: 'dbi_details' })}
              </div>
            )}
          </CloumsCenter>
        );
      },
    },
  ];

  return (
    <Table
      className="dbi-table-sticky"
      bordered="all"
      records={tableData || []}
      columns={annualColumns}
      addons={[
        pageable(),
        scrollable({
          minWidth: 400,
        }),
        autotip({
          isError: tableData.length === 0,
          errorText: (
            <NoData content={formatMessage({ id: 'common_nodata' })} />
          ),
        }),
      ]}
    />
  );
}
